
import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';

const TotalTransactionChart = ({ totalData }) => {

  const config = {
    colors: {
      primary: '#696cff',
      success: '#d40c50',
    },
    colors_dark: {
      cardColor: '#2b2c40',
      textMuted: '#a5a6c3',
      headingColor: '#d6d7f3',
      borderColor: '#393b58',
      
    },
    colors_label: {
      primary: '#696cff',
      secondary: '#a5a6c3',
    }
  };

  const isDarkStyle = false;
  const textMuted = isDarkStyle ? config.colors_dark.textMuted : '#8d90a3ff';
  const borderColor = isDarkStyle ? config.colors_dark.borderColor : '#eceef1';

const { series, categories } = useMemo(() => {
    const positiveData = [];
    const negativeData = [];
    const categories = [];

    totalData.forEach(item => {
        categories.push(item.name);
        if (item.value >= 0) {
            positiveData.push(item.value);
            negativeData.push(0);
        } else {
            positiveData.push(0);
            negativeData.push(item.value);
        }
    });

    const positiveSeries = {
        name: 'Amount',
        data: positiveData,
    };
    const negativeSeries = {
        name: 'Amount',
        data: negativeData,
    };

    return {
        series: [positiveSeries, negativeSeries],
        categories: categories,
    };
}, [totalData]);
  
const chartOptions = {
    chart: {
        height: 300,
        stacked: true,
        type: "bar",
        parentHeightOffset: 0,
        toolbar: { show: false },
    },
    tooltip: {
        y: {
            formatter: function (val) {
                 return "₹" + val.toFixed(0);
            },
        },
    },
    legend: { show: false },
    dataLabels: { enabled: false },
    colors: [config.colors.primary, config.colors.success],
    grid: {
        borderColor: borderColor,
        xaxis: { lines: { show: true } },
        yaxis: { lines: { show: false } },
        padding: { top: -5, bottom: -25 },
    },
    states: {
        hover: { filter: { type: "none" } },
        active: { filter: { type: "none" } },
    },
    plotOptions: {
        bar: {
            borderRadius: 5,
            barHeight: "30%",
            horizontal: true,
            endingShape: 'rounded',
            startingShape: 'flat'

        },
    },
    xaxis: {
        position: "top",
        axisTicks: { show: false },
        axisBorder: { show: false },
        categories: categories,
         forceNiceScale: true, 
        labels: {
            formatter: function (val) {
                return Math.abs(Math.round(val));
            },
            style: { colors: textMuted, fontFamily: "Inter" },
        },
    },
    yaxis: {
        labels: {
            show: true,
            style: {
                colors: textMuted,
                fontFamily: "Inter",
                 fontSize: "12px" 
            }
        }
    },
    series: series,
};

  return (
    <div className='pt-2'>
      
     
        <Chart
          options={chartOptions}
          series={chartOptions.series}
          type="bar"
          height={218}
        />
      
    </div>
  );
};

export default TotalTransactionChart;